import { faLocationDot } from "@fortawesome/pro-regular-svg-icons";
import type { FinderProfileRequestDetailed } from "../../models_NEXT/fyndr/FinderProfileRequest";
import { FinderProfileRequest } from "../../models_NEXT/fyndr/FinderProfileRequest";
import ModelRelation from "../misc/modelRelation/ModelRelation";
import ModelRelationType from "../misc/modelRelation/ModelRelationType";

export class FinderProfileRequestModelRelation extends ModelRelation {
  public static type = new ModelRelationType(
    "leadfinder",
    "finderprofilerequest",
    faLocationDot,
  );
  public readonly customerId: string;

  public constructor(id: string, customerId: string) {
    super(id, FinderProfileRequestModelRelation.type);
    this.customerId = customerId;
  }

  public useFinderProfileRequest(): FinderProfileRequestDetailed {
    return FinderProfileRequest.ofCustomer(this.customerId).getDetailed.use();
  }

  public useOptionalFinderProfileRequest():
    | FinderProfileRequestDetailed
    | undefined {
    return FinderProfileRequest.ofCustomer(this.customerId).findDetailed.use();
  }
}
